var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgConfirmSubmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.166,
    height: 18.023,
    viewBox: "0 0 15.166 18.023"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ICN_Confirma Depunere_Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.428.848a9.32 9.32 0 00-2.387 0A3.637 3.637 0 00.819 4.469c-.005 3.526-.034 5.839 0 9.316a3.221 3.221 0 003.18 3.437c2.673 0 4.149-.016 6.89 0a3.237 3.237 0 003.479-2.955",
    "data-name": "Path 936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#009a44",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 65",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.798 12.2H6.797c-.661 0-1.2-.539-1.2-1.201v-.728c0-.66.539-1.199 1.2-1.199h.961l.237-.354c.803-1.196.726-2.53.513-3.457h.264l-.666-1.19a2.283 2.283 0 01-.287-1.116C7.819 1.767 8.707.8 9.799.8c1.09 0 1.976.967 1.976 2.155 0 .434-.118.852-.34 1.21l-.029.045-.022.05c-.266.592-1.038 2.662.172 4.46l.238.352h1.004c.662 0 1.201.538 1.201 1.2v.727c0 .662-.539 1.201-1.201 1.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.798 11.4c.22 0 .401-.18.401-.401v-.728a.4.4 0 00-.401-.399h-.578a1.6 1.6 0 01-1.327-.706c-1.441-2.14-.547-4.547-.239-5.234.03-.066.064-.13.102-.19.143-.231.219-.503.219-.787 0-.747-.528-1.355-1.176-1.355-.65 0-1.18.608-1.18 1.355 0 .259.064.509.184.725.05.089.091.181.123.276.516 1.172.959 3.382-.267 5.208a1.6 1.6 0 01-1.328.708h-.534a.4.4 0 00-.399.4v.727c0 .22.179.401.399.401h6m0 1.6h-6a2 2 0 01-1.999-2.001v-.728c0-1.104.894-1.999 1.999-1.999h.534c1.132-1.687.065-3.811.065-3.811h.011a3.08 3.08 0 01-.388-1.506C7.019 1.325 8.265 0 9.799 0c1.534 0 2.776 1.324 2.776 2.955 0 .604-.17 1.164-.461 1.632-.214.476-.878 2.225.106 3.685h.578a2 2 0 012.001 2v.727A2.002 2.002 0 0112.798 13z",
    fill: "#009a44"
  })))));
}

export default SvgKpmgConfirmSubmission;